import { useNavigate } from 'react-router-dom';
import { guideArticles } from '@/mocks/articles';

export default function GuidesGrid() {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12">
          <span className="text-sm font-semibold text-primary-600 tracking-wider uppercase">Latest</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-bold text-foreground-950">
            Latest AllChinaBuy Guides
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto">
          {guideArticles.map((article) => (
            <button
              key={article.slug}
              onClick={() => navigate(`/${article.slug}/`)}
              className="text-left bg-white rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 hover:shadow-md transition-all group flex flex-col"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium bg-white/90 backdrop-blur-sm text-primary-700 rounded-full">
                  {article.category}
                </span>
              </div>
              <div className="flex-1 p-5 md:p-6">
                <div className="flex items-center gap-2 mb-3 text-xs text-foreground-500">
                  <span>{article.readTime} min read</span>
                  <span>•</span>
                  <span>{article.date}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 line-clamp-2">
                  {article.desc}
                </p>
                <div className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-600">
                  Read More
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}